import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IUserModel } from "src/app/core/models/masters/user-master.model";
import { GenericListView } from "src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view";

@Component({
    selector: 'app-chip',
    styleUrls: ['./chip.component.css'],
    templateUrl: './chip.component.html'
})

export class ChipComponent{
    @Input('filterItems') selectedFilters: any;
    @Output() removeFilter = new EventEmitter();
    ngOnit(){
        alert(JSON.stringify(this.selectedFilters));
    }
    getActualString(str: string) {
        let finalResult = str.charAt(0).toUpperCase() + str.slice(1);
        return finalResult.replace(/([A-Z])/g, " $1").trim();
    
      }
    
 }
    

